import {Controller} from "stimulus"

export default class extends Controller {

    static targets = [
    ]

    initialize(){
    }

    close(e){
        e.preventDefault()
        e.currentTarget.classList.add("is-open")
        this.element.classList.remove("is-open")
    }

    open(e){
        e.preventDefault()
        e.currentTarget.classList.add("is-open")
        this.element.classList.add("is-open")
    }

    toggle(e){
        e.preventDefault()
        e.currentTarget.classList.toggle("is-open")
        this.element.classList.toggle("is-open")
    }

}